import { columnOrderingFeature, columnVisibilityFeature, createCoreRowModel, rowSelectionFeature, tableFeatures } from '@tanstack/react-table'

// One shared definition so the caller's table instance and DataGrid agree on the same type: a
// renderer typed against a `TFeatures extends TableFeatures` generic cannot call
// `row.getVisibleCells()`, so the concrete object has to be the type rather than a parameter.
// Ordering is part of the contract: stickyLeft/RightColumnIds are documented as depending on the
// visible display order, which the caller controls through columnOrder state.
export const dataGridFeatures = tableFeatures({
  columnOrderingFeature,
  columnVisibilityFeature,
  rowSelectionFeature,
  coreRowModel: createCoreRowModel(),
})

export type DataGridFeatures = typeof dataGridFeatures
